import { useEffect, useState } from "react";
import { ExternalLink, FileText, Loader2 } from "lucide-react";
import { adminApi } from "../../lib/api";

export const DocPreview = ({ fileId, label, testId }) => {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!fileId) return undefined;
    let url;
    adminApi.get(`/admin/files/${fileId}`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setDoc({ url, pdf: r.data.type === "application/pdf" }); })
      .catch(() => setError(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId]);

  return (
    <div data-testid={testId} className="border border-white/10 bg-[#0B1120] p-3">
      <div className="mb-2 flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">{label}</span>
        {doc && (
          <a href={doc.url} target="_blank" rel="noreferrer" data-testid={`${testId}-open`} className="flex items-center gap-1 text-xs text-orange-300 hover:text-orange-200">
            Open <ExternalLink className="h-3 w-3" />
          </a>
        )}
      </div>
      <div className="flex h-40 items-center justify-center overflow-hidden bg-black/20">
        {!fileId && <span className="text-sm text-slate-500">Not provided</span>}
        {fileId && error && <span className="text-sm text-red-400">Could not load file</span>}
        {fileId && !doc && !error && <Loader2 className="h-5 w-5 animate-spin text-slate-500" />}
        {doc && (doc.pdf ? <FileText className="h-10 w-10 text-slate-400" /> : <img src={doc.url} alt={label} className="h-full w-full object-contain" />)}
      </div>
    </div>
  );
};
